module.exports = {"id":"188128","name":"Manu Barreiro","rating":"72","photo":"./data/images/photos/0/188128.png","club":{"name":"Gimnàstic","logo":"./data/images/clubs/Gimnastic.png"},"positions":["BU"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuBarreiro0.json
// module id = 2674
// module chunks = 0